import { NgModule, APP_INITIALIZER }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { DocumentsCercadorComponent } from './documents-cercador.component';
import { DocumentsListComponent } from './documents-list/documents-list.component';
import { DocumentsFiltersComponent } from './documents-filtre/documents-filtre.component';

import { DocumentsService } from '../services/documents-service/documents.service';
 
import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  declarations: [
    DocumentsCercadorComponent,
    DocumentsListComponent,
    DocumentsFiltersComponent
  ],
  exports:      [
    DocumentsCercadorComponent
  ],
  providers:    [ 
    DocumentsService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    } 
  ]
})
export class DocumentsSearchModule { }
